import {Component, OnInit, ViewChild} from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { UtilsService } from "../shared/shared.module";

@Component({
  selector: 'app-validate-account',
  templateUrl: './validate-account.component.html',
  styleUrls: ['./validate-account.component.css']
})
export class ValidateAccountComponent implements OnInit {

  environment: any;
  isLoading: boolean = false;

  message:string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private utilsService: UtilsService,
  ) { }

  ngOnInit() {
    this.environment = environment;

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.utilsService.scrollTop();
    });

    this.route.params.subscribe(params => {
      let accept = params['accept'];
      let email = params['email'];
      if (accept && email) {
        this.isLoading = true;
        this.http.get(environment.API_PATH + '/user/' + email + '/accept/' + accept)
	      .subscribe(
          res => {
            this.isLoading = false;
            this.message = "Votre compte a bien été validé";
          },
          err => {
            this.isLoading = false;
            this.message = "Il semblerait que ce lien ne soit plus valide";
          });
      }
      else
        this.message = "Il semblerait que ce lien ne soit plus valide";
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/validate-account/validate-account.component.ts